const INDEX_LABEL: Record<string, string> = {
    DI: "CDI",
    IPCA: "IPCA (inflação)",
    "IGP-M": "IGP-M",
    IGPM: "IGP-M",
    "PRÉ": "taxa prefixada",
    PRE: "taxa prefixada",
    "SEM-ÍNDICE": "sem correção",
    TR: "TR",
    DOLAR: "dólar",
    INPC: "INPC",
};

const formatRate = (rate: number) =>
    rate.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const formatDebentureYield = (
    index?: string | null,
    interestRate?: number | null,
): string => {
    const idx = (index ?? "").trim();
    const indexLabel = INDEX_LABEL[idx] ?? idx;
    const rate = interestRate != null && !Number.isNaN(Number(interestRate))
        ? Number(interestRate)
        : null;

    if (!indexLabel && (rate == null || rate === 0)) {
        return "Como rende: definido na escritura da debênture";
    }

    if (rate == null || rate === 0) {
        return indexLabel ? `Como rende: ${indexLabel}` : "Como rende: definido na escritura da debênture";
    }

    const rateLabel = formatRate(rate);
    if (idx === "PRÉ" || idx === "PRE" || idx === "SEM-ÍNDICE") {
        return `Como rende: ${rateLabel}% ao ano`;
    }

    if (!indexLabel) {
        return `Como rende: ${rateLabel}% ao ano`;
    }

    return `Como rende: ${indexLabel} + ${rateLabel}% ao ano`;
};

export const formatDebentureYieldShort = (
    index?: string | null,
    interestRate?: number | null,
): string | null => {
    const idx = (index ?? "").trim();
    const indexLabel = INDEX_LABEL[idx] ?? idx;
    const rate = interestRate != null && !Number.isNaN(Number(interestRate))
        ? Number(interestRate)
        : null;

    if (!indexLabel && (rate == null || rate === 0)) {
        return null;
    }

    if (rate == null || rate === 0) {
        return indexLabel || null;
    }

    const rateLabel = formatRate(rate);
    if (!indexLabel || idx === "PRÉ" || idx === "PRE" || idx === "SEM-ÍNDICE") {
        return `${rateLabel}% a.a.`;
    }

    return `${indexLabel} + ${rateLabel}% a.a.`;
};
